module.exports = __webpack_public_path__ + "img/waitting.4c04994a.png";